import * as React from 'react'
// @ts-expect-error this is an image
import image from '../../../images/safety-hq-monogram-white.png'

export const LogoComponent: React.FC = () => {
  return <img alt="SafetyHQ Monogram" src={image} width={200} height={200} />
}
